import * as Sentry from '@sentry/browser';
import createSentryMiddleware from 'redux-sentry-middleware';

/**
 * Sentry event modifications before sending to service
 * @param {Object} event Event object built by sentry on exception
 * @returns {Object} modified Event
 */
const beforeSend = event => ({
  ...event,
  fingerprint: ['{{ default }}'],
});

const initializeSentry = () => {
  if (process.env.REACT_APP_SENTRY_ENABLED) {
    const versionMatch = (process.env.REACT_APP_VERSION || '').match(/\d+\.\d+/);
    const release = versionMatch ? `backoffice@${versionMatch}` : '-';
    Sentry.init({
      dsn        : 'https://28b4ddf12f754819b128408e56fa8514@sentry.io/1772210',
      environment: process.env.REACT_APP_ENVIRONMENT,
      release,
      beforeSend,
    });
  }
};

const getSentryReduxMiddleware = () => createSentryMiddleware(Sentry, {
  stateTransformer: () => ({}),
});

export { initializeSentry, beforeSend, getSentryReduxMiddleware };
